import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import Amount from "@/models/Shared/Amount";
import PeriodType from "@/models/Shared/PeriodType";

export default class DepositPaymentOrderSettings extends BaseProductSettings  {
    oneApprovalThresholdEnabled: boolean = false;
    twoApprovalThresholdEnabled: boolean = false;
    threeApprovalThresholdEnabled: boolean = false;
    oneApprovalThreshold: Amount = new Amount();
    twoApprovalThreshold: Amount = new Amount();
    threeApprovalThreshold: Amount = new Amount();
    noticePeriodEnabled: boolean = false;
    noticePeriodType: PeriodType;
    noticePeriodValue: number;
    restrictToWorkingDay: boolean = false;
}